var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 12.5C11.7884 12.5 13.4 10.8213 13.4 8.75C13.4 6.67871 11.7884 5 9.8 5C7.81156 5 6.2 6.67871 6.2 8.75C6.2 10.8213 7.81156 12.5 9.8 12.5ZM12.32 13.4375H11.8503C11.2259 13.7363 10.5312 13.9062 9.8 13.9062C9.06875 13.9062 8.37687 13.7363 7.74969 13.4375H7.28C5.19312 13.4375 3.5 15.2012 3.5 17.375V18.5938C3.5 19.3701 4.10469 20 4.85 20H14.75C15.4953 20 16.1 19.3701 16.1 18.5938V17.375C16.1 15.2012 14.4069 13.4375 12.32 13.4375ZM21.4044 9.67578L20.6225 8.85254C20.4931 8.71484 20.2822 8.71484 20.15 8.84961L17.2025 11.8965L15.9228 10.5547C15.7934 10.417 15.5825 10.417 15.4503 10.5518L14.66 11.3691C14.5278 11.5039 14.5278 11.7236 14.6572 11.8613L16.955 14.2725C17.0844 14.4102 17.2953 14.4102 17.4275 14.2754L21.4016 10.168C21.5309 10.0303 21.5337 9.81055 21.4044 9.67578Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCheck);
export default __webpack_public_path__ + "static/media/personCheck.c0b4071d.svg";
export { ForwardRef as ReactComponent };